import { useBreakpoint } from "src/hooks";

export const useLanguageSwitcherState = () => {
  const { isMobile } = useBreakpoint();

  const getPopoverPlacement = () => {
    return isMobile ? "bottom" : "bottom-end";
  };

  return {
    getPopoverPlacement,
  };
};
